<template>
  <div
    class="meeting-room-container flex flex-col justify-between"
    @mouseenter="
      setCursor($t('more-info'), cursorAction, {
        'font-size': '14px',
        width: '100px',
        height: '100px',
      })
    "
    @mouseleave="
      setCursor(null, null, {
        'font-size': '14px',
        width: '25px',
        height: '25px',
      })
    "
  >
    <div>
      <img :src="article?.featuredImage" class="article-image" />
      <div class="px-0 lg:px-8">
        <div class="pb-4 lg:pb-5 pt-6 lg:pt-11 article-date" v-if="showDate == true">
          {{ formatDate }}
        </div>
        <div class="pb-4 txt-q" v-html="article.title"></div>
        <p class="pb-6 xl:pb-8" v-html="formattedPerex"></p>
        <button
          v-if="showButton == true"
          class="xl:hidden pointer-events-auto whitespace-nowrap bg-transparent border rounded-full border-black px-4 py-2 text-sm"
          @click="cursorAction"
        >
          {{ $t("Read") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useLocalePath } from "#imports"; // Nuxt auto-import

export default {
  name: "MeetingRoom",
  props: {
    article: {
      type: Object,
      required: true,
    },
    setCursor: {
      required: true,
      type: Function,
    },
    showDate: {
      type: Boolean,
      default: true
    },
    showButton: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const localePath = useLocalePath();
    return { localePath };
  },
  data() {
    return {
      formattedPerex: "",
    };
  },

  computed: {
    formatDate() {
      const date = new Date(this.article.date);
      return (
        ("0" + date.getDate()).slice(-2) +
        "." +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "." +
        date.getFullYear()
      );
    },
  },

  mounted() {
    this.formattedPerex = this.replaceBlockquotesAndRemoveStyles(
      this.article.perex
    );
  },
  methods: {
    cursorAction() {
      return navigateTo(
        this.localePath({
          name: "article-id",
          params: { id: this.article.slug },
        })
      );
    },

    replaceBlockquotesAndRemoveStyles(htmlContent) {
      // Create a DOM parser to parse the HTML content
      if (!htmlContent) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");

      // Remove styles from all elements
      const allElements = doc.querySelectorAll("*");
      allElements.forEach((element) => {
        element.removeAttribute("style");
      });

      // Find all blockquote elements
      const blockquotes = doc.querySelectorAll("blockquote");

      // Replace each blockquote element with the custom div structure
      blockquotes.forEach((blockquote) => {
        // Extract text content
        const quoteText = blockquote.innerText.trim();

        // Create the new element with the desired format
        // Replace the blockquote with the new element
        blockquote.outerHTML = `
                        <div class="quote">
                            <div class="quote-sign">“</div>
                            <div class="quote__text mb-12">
                                ${quoteText}
                            </div>
                            <div class="quote-sign">“</div>
                        </div>
                    `;
      });

      const pres = doc.querySelectorAll("pre");
      pres.forEach((pre) => {
        const content = pre.innerHTML;
        pre.outerHTML = content;
      });

      // Serialize the document back to a string and return it
      return doc.documentElement.innerHTML;
    },
  },
};
</script>

<style scoped lang="scss">
.article-date {
  font-family: Roboto;
  font-weight: 600;
  font-size: 16px;
}

.meeting-room-container {
  display: block;
  width: 100%;
  max-width: 700px;

  .article-image {
    aspect-ratio: 380 / 213;
    width: 100%;
    object-fit: cover;
  }

  p {
    font-size: 16px;
    font-weight: 300;
  }

  @media screen and (max-width: 1024px) {
    max-width: 100%;
  }
}
</style>
